'use client';

import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import zhHK from 'antd/locale/zh_HK';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/en';
import updateLocale from 'dayjs/plugin/updateLocale';
import { useEffect } from 'react';

// 设置语言
const Language = (props) => {
    const { locale } = props;
    const init = async () => {
        const NEXT_LOCALE = locale; // await getCookie('NEXT_LOCALE')   // || 'zh'
        const mapLanguage = {
            zh: 'zh-cn',
            en: 'en',
        };
        dayjs.locale(mapLanguage[NEXT_LOCALE]);
        dayjs.extend(updateLocale);
        dayjs.updateLocale(mapLanguage[NEXT_LOCALE], {
            weekStart: 0,
        });
    };

    useEffect(() => {
        // init();

        init();
        // const url = new URL(window.location.href);
        // url.searchParams.delete('locale');
        // window.history.replaceState(null, '', url.toString());
    }, [locale]);
    return null;
};

const getAntdLanguage = (locale) => {
    return {
        zh: zhCN,
        en: enUS,
        // zht: zhHK,
    }[locale];
};

export { getAntdLanguage };

export default Language;
